export enum messageContentEnum {
  RASS_NO_RESULTS = 'Aucun résultat trouvé',
  RASS_MAX_RESULTS = 'Le nombre de résultats est trop important pour être affiché. Merci d’affiner votre recherche.',
  RASS_TIMEOUT = 'Une erreur est survenue lors de la recherche. ' +
    'L’appel à l’Annuaire Santé a dépassé le temps limite et a donc été interrompu. ' +
    'Veuillez réessayer ultérieurement.',
  LDAP_PERSON_NOT_FOUND = 'Une erreur est survenue lors de la création de(s) habilitation(s). ' +
    'La personne n’existe pas dans l’annuaire CPS. Veuillez réessayer ultérieurement. ' +
    'Si le problème persiste, contacter l’administrateur du site.',
  HABILITATION_PERSONNE_MORALE_ALREADY_EXISTS_PLUSIEURS = 'Une erreur est survenue lors de la création des habilitations. ' +
    'L’une des habilitations que vous souhaitez créer (au moins) existe déjà. ' +
    'Veuillez retirer l’habilitation pour la structure {{structure}}, et le tiers {{tiers}}.',
  HABILITATION_ALREADY_EXISTS = 'Une erreur est survenue lors de la création de l’habilitation. L’habilitation que vous souhaitez créer existe déjà.',
  HABILITATION_ALREADY_EXISTS_PLUSIEURS = 'Une erreur est survenue lors de la création des habilitations. ' +
     'L’une des habilitations que vous souhaitez créer (au moins) existe déjà. Veuillez retirer l’habilitation pour',
  RASS_ERROR = 'Une erreur est survenue lors de la recherche.',
  RASS_ERROR_LIMIT_CONSULTATION_PM = `Vous ne pouvez pas sélectionner plus {{limitConsultationPM}} de structures bénéficiaires.`,
  SUCCESS_CREATION = 'L’habilitation a été créée avec succès.',
  ERROR_CREATION = 'Problème lors de la création de l’habilitation.',
  ERROR_EFFACEMENT = 'Problème lors de l’effacement de l’habilitation.',
  ERROR_CONNEXION = 'Utilisateur non valide',
  USSAGE_NO_DISPO = 'Il n’est pas possible pour le moment de gérer les habilitations pour l’offre correspondante ' +
    'via ce portail. Merci de télécharger et remplir le ' +
    'formulaire de déclaration d’administrateurs techniques',
  STRUC_NO_VALID = 'Cette structure n’étant plus active, vous ne pouvez attribuer de nouvelles habilitations dessus',
  STRUCS_NO_VALID = 'Les structures suivantes n’étant plus actives, vous ne pouvez attribuer de nouvelles habilitations dessus:\n',
  DOMAINE_NO_VALID = 'Domaine non valide',
  STRUCTURE_NO_RESULTS = 'Aucune structure trouvée pour la duplication',
  HABILITATION_NOT_FOUND = 'Aucune habilitation trouvée',
  ERROR_DÉTACHER_STRUCTURE = 'Une erreur à détacher la structure.',
  ERROR_DÉTACHER_STRUCTURE_HAB_EN_ATTENTE = 'Il y a une habilitation en attente de validation.',
  PROFILE_NO_RESULTS = 'Aucune habilitation trouvée',
  DOMAINE_IDENTIQUE = 'Vous ne pouvez pas générer une habilitation à l’identique de l’habilitation d’origine. Veuillez changez le domaine et/ou le sous-domaine pour  : ',
  NB_HABILITATIONS_TOO_HIGH = 'Opération impossible. Le nombre d’habilitations à dupliquer dépasse le nombre autorisé.',
}
